import React from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { CashoutType } from "@gp/hub";
import { useRootAppStore } from "@hooks";
import { Bet } from "@models";
import { ISOToDisplayCode} from "@utils";
import CashoutIndicator from "./cashout/CashoutIndicator";
import { OpenCashoutModalType } from "@data-types/my-bets/OpenCashoutModal";
import { THEME_SETTINGS } from "@theme-settings";

export default observer(function MyBetsCashoutButton(props: {
	bet: Bet;
	openCashoutModal: (args: OpenCashoutModalType) => void;
}) {
	const { t } = useTranslation("mybets");

	const rootStore = useRootAppStore();

	const buttonCalssNames = classNames(
		"widget--bets__btn widget--bets__cashout btn btn--sml btn--block btn--cashout btn--icon",
		{
			inc: props.bet.indicator === 1,
			dec: props.bet.indicator === -1,
		}
	);

	if (
		props.bet.displayedAmount == null ||
		props.bet.displayedAmount == "0.00"
	) {
		return null;
	}

	if (props.bet.cType == undefined) {
		console.error("cType can not be null");
		return null;
	}

	const isButtonDisabled =
		rootStore.myBetsViewStore.cashoutStore.isCashoutFormSubmitting;

	const handleButtonClick = () => {
		props.openCashoutModal({
			userId: props.bet.userId || "",
			id: props.bet.id,
			calculatedCashoutAmount: props.bet.calculatedCashoutAmount,
			displayedAmount: props.bet.displayedAmount || "",
			cType: props.bet.cType || CashoutType.NO_CACHE_OUT,
			isLive: props.bet.isLive,
			isChangeAccepted: false,
			liveBetSlipCountdown: props.bet.liveBetSlipCountdown,
		});
	};

	if (
		props.bet.cType !== CashoutType.JACKTIME ||
		props.bet.calculatedCashoutAmount < 0
	) {
		return null;
	}

	return (
		<button
			className={buttonCalssNames}
			type="button"
			disabled={isButtonDisabled}
			onClick={handleButtonClick}
		>
			<CashoutIndicator bet={props.bet} />
			{t<string>("CASHOUT.BUTTON_LABEL")} {props.bet.displayedAmount}{" "}
			{ISOToDisplayCode(THEME_SETTINGS.defaultCurrency)}
		</button>
	);
});
